import React, { useState } from "react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Input, Toast } from "../ui";
import { appConstants } from "../_constants/app.constants";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${appConstants.API_URL}/api/auth/forgot-password`, {
        email: email.trim(),
      });
    } catch {
      // Keep the same response to avoid revealing registered email addresses.
    } finally {
      setSubmitted(true);
      setSubmitting(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-gradient-to-b from-cream via-white to-cream-deep px-4 py-12">
      <div className="pointer-events-none absolute inset-0 bg-noise opacity-30 mix-blend-multiply" aria-hidden />
      <div className="relative z-10 mx-auto flex min-h-[80vh] w-full max-w-md items-center">
        <Card className="w-full overflow-hidden">
          <div className="h-1 bg-gradient-to-r from-gold via-gold-bright to-arena-bright" />
          <CardHeader className="pb-1 pt-6">
            <h1 className="font-display text-3xl font-extrabold text-ink">Recuperar contraseña</h1>
            <p className="mt-1 text-sm text-ink-muted">
              Te enviaremos un enlace seguro para elegir una contraseña nueva.
            </p>
          </CardHeader>
          <CardBody className="pb-6">
            {submitted ? (
              <>
                <Toast kind="success" className="mb-4">
                  Si existe una cuenta con <strong>{email.trim()}</strong>, recibirás un email con el enlace.
                </Toast>
                <p className="mb-5 text-sm leading-relaxed text-ink-muted">
                  Revisa también la carpeta de spam. El enlace caduca y solo puede utilizarse una vez.
                </p>
                <Button as={RouterLink} to="/login" variant="primary" size="lg" className="w-full">
                  Volver al login
                </Button>
              </>
            ) : (
              <>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Input
                    label="Email de tu cuenta"
                    type="email"
                    autoComplete="email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                  />
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="w-full"
                    disabled={submitting}
                  >
                    {submitting ? "Enviando..." : "Enviar enlace de recuperación"}
                  </Button>
                </form>
                <p className="mt-4 text-sm">
                  <RouterLink to="/login" className="font-semibold text-arena-bright hover:underline">
                    Volver al login
                  </RouterLink>
                </p>
              </>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
}
